import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import VehicleSelect from "./components/VehicleSelect";
import TerrainSelect from "./components/TerrainSelect";
import GearSelect from "./components/GearSelect";
import EventTypeSelect from "./components/EventTypeSelect";


const states = [
  'AB', 'AK', 'AL', 'AR', 'AZ',
  'BC', 'Baja California', 'Baja Sur',
  'CA', 'CO', 'CT',
  'DC', 'DE',
  'FL',
  'GA',
  'HI',
  'IA', 'ID', 'IL', 'IN',
  'KS', 'KY',
  'LA',
  'MA', 'MB', 'MD', 'ME', 'MI', 'MN', 'MO', 'MT',
  'NB', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NS', 'NT', 'NU', 'NV', 'NY',
  'OH', 'OK', 'ON', 'OR',
  'PA', 'PE',
  'QC',
  'RI',
  'SC', 'SD', 'SK',
  'TN', 'TX',
  'UT',
  'VA', 'VT',
  'WA', 'WI', 'WV',
  'YK'
];


const CreateEvent = () => {
  const navigate = useNavigate();

  const [event, setEvent] = useState(null);
  const [formData, setFormData] = useState({
    id : null,
    name: "",
    summary: "",
    start_time: "",
    end_time: "",
    location: "",
    terrain: "",
    recommended_vehicle: "",
    required_gear: "",
    gpx_file_url: "",
    is_public: true,
    dogs_permitted: false,
    children_permitted: false,
    open_for_registration: true,
    eventtype: "",
    begin_hour_time : null,
    end_hour_time : null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.start_time || !formData.end_time|| !formData.max_rigs) {
      toast.error("Name, Start Time, End Time and max_rigs are required.");
      return;
    }


    // Transform for the save as a string
    if (Array.isArray(formData.required_gear)) {
      formData.required_gear = formData.required_gear.join(",");
    }

    if (Array.isArray(formData.recommended_vehicle)) {
      formData.recommended_vehicle = formData.recommended_vehicle.join(",");
    }

    if (Array.isArray(formData.terrain)) {
      formData.terrain = formData.terrain.join(",");
    }


    try {
      const response = await axios.post(
        "/otgservices/createEvent.php",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      var event = formData;
      event.id = response.data.id;
      setEvent(event);
      if (response.data.status === "success") {
        toast.success("Event created successfully!");
        // Go to the Edit Event Page
        const eventId =response.data.id;
        navigate(`/events/edit-event/${eventId}`, {state: {event}});
      } else {
        toast.error("Failed to create event: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      toast.error("Error submitting event. Please try again.");
      console.error(error);
    }
  };

  const handleCancel = () => {
    navigate("/events");
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-bold mb-4 text-center">Create Event</h2>
      <form
          onSubmit={handleSubmit}
          className="max-w-xl mx-auto bg-white p-6 rounded shadow space-y-4"
      >
        <div>
          <label htmlFor="name" className="block mb-1 text-sm font-medium">
            Event Name
          </label>
          <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
          />
        </div>

        <div>
          <label htmlFor="summary" className="block mb-1 text-sm font-medium">
            Event Summary
          </label>
          <input
              id="summary"
              name="summary"
              type="text"
              value={formData.summary}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <label htmlFor="start_time" className="block mb-1 text-sm font-medium">
            Start Date
          </label>
          <input
              id="start_time"
              name="start_time"
              type="date"
              value={formData.start_time}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
          />
        </div>

        <div>
          <label htmlFor="end_time" className="block mb-1 text-sm font-medium">
            End Date
          </label>
          <input
              id="end_time"
              name="end_time"
              type="date"
              value={formData.end_time}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
          />
        </div>
        <div>
          <label htmlFor="begin_hour_time" className="block mb-1 text-sm font-medium">
            Start Time
          </label>
          <input
              id="begin_hour_time"
              name="begin_hour_time"
              type="text"
              value={formData.begin_hour_time}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
          />
        </div>

        <div>
          <label htmlFor="end_hour_time" className="block mb-1 text-sm font-medium">
            End Time
          </label>
          <input
              id="end_hour_time"
              name="end_hour_time"
              type="text"
              value={formData.end_hour_time}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
          />
        </div>


        <EventTypeSelect
            value={formData.eventtype}
            onChange={(e) =>
                setFormData(prev => ({...prev, eventtype: e.target.value}))
            }
        />

        <TerrainSelect
            selectedTerrain={formData.terrain}
            setSelectedTerrain={(terrain) =>
                setFormData(prev => ({...prev, terrain}))
            }
        />

        <VehicleSelect
            selectedVehicles={formData.recommended_vehicle}
            setSelectedVehicles={(vehicles) =>
                setFormData(prev => ({...prev, recommended_vehicle: vehicles}))
            }
        />

        <GearSelect
            selectedGear={formData.required_gear}
            setSelectedGear={(gear) => {
              setFormData(prev => ({...prev, required_gear: gear}))
            }}
        />

        <div>
          <label className="block mb-1 text-sm font-medium">State</label>
          <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              list="us-states"
              className="border rounded px-3 py-2 w-full"
          />

          <datalist id="us-states">
            {states.map((state) => (
                <option key={state} value={state}/>
            ))}
          </datalist>

        </div>
        <div>
          <label className="block mb-1 text-sm font-medium" htmlFor="max_rigs">Max Rigs (including your self)</label>
          <input
              id="max_rigs"
              name="max_rigs"
              type="number"
              value={formData.max_rigs}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
          />
        </div>

        <div className="flex flex-wrap gap-4">
          <label className="flex items-center space-x-2">
            <input
                type="checkbox"
                name="children_permitted"
                checked={formData.children_permitted}
                onChange={handleChange}
            />
            <span>Children Allowed</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
                type="checkbox"
                name="dogs_permitted"
                checked={formData.dogs_permitted}
                onChange={handleChange}
            />
            <span>Dogs Allowed</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
                type="checkbox"
                name="is_public"
                checked={formData.is_public}
                onChange={handleChange}
            />
            <span>Public</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
                type="checkbox"
                name="open_for_registration"
                checked={formData.open_for_registration}
                onChange={handleChange}
            />
            <span>Open for Registration</span>
          </label>
        </div>

        <div>
          <label htmlFor="initials" className="block mb-1 text-sm font-medium">
            <a
                href="https://www.overlandtrailguides.com/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600">Overland Trail Guides Terms of Use</a>.
          </label>
          <input
              type="checkbox"
              id="initials"
              name="initials"
              checked={formData.initials}
              onChange={handleChange}
              className="mr-2"
              required
          />
          <span>By checking this box I agree to the Terms of Use</span>
        </div>
        <div className="flex justify-between">
          <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
              type="submit"
              className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
          >
            Create Event
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEvent;

